
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'clear-day': {
    width: 100,
    height: 100,
    viewBox: '0 0 100 100',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M71.997 51.999h-3.998a2 2 0 1 1 0-3.999h3.998a2 2 0 0 1 0 3.999zm-7.855-13.311a2 2 0 1 1-2.828-2.828l2.828-2.828a2 2 0 1 1 2.828 2.828l-2.828 2.828zm-14.141 23.31c-6.627 0-12-5.372-12-11.998 0-6.627 5.372-11.999 12-11.999 6.627 0 11.998 5.372 11.998 11.999 0 6.626-5.371 11.998-11.998 11.998zm0-19.997A8 8 0 1 0 50 58a8 8 0 0 0 .001-15.999zm0-7.999a2 2 0 0 1-2-2v-3.999a2 2 0 0 1 4 0v3.999c0 1.104-.897 2-2 2zM35.86 38.688l-2.828-2.828a2 2 0 1 1 2.828-2.828l2.828 2.828a2 2 0 1 1-2.828 2.828zM34.002 50a2 2 0 0 1-2 1.999h-4a1.999 1.999 0 0 1 0-3.999h4a2 2 0 0 1 2 2zm1.858 11.312a2 2 0 1 1 2.828 2.828l-2.828 2.828a2 2 0 1 1-2.828-2.828l2.828-2.828zm14.141 4.686a2 2 0 0 1 2 1.999v4a2 2 0 0 1-4 0v-4a2 2 0 0 1 2-1.999zm14.141-4.686l2.828 2.828a2 2 0 1 1-2.828 2.828l-2.828-2.828a2 2 0 1 1 2.828-2.828z"/>'
  }
})
